export default __webpack_public_path__ + "static/media/webinnova.468369d6.png";